module.exports = __webpack_public_path__ + "img/pic3.0ccdc9e1.png";